/**
 * DoctorAvatar
 * Renders either the doctor's uploaded headshot (data URL from backend) or a
 * warm initials-in-circle placeholder. Deterministic tint from username so the
 * same doctor always gets the same accent.
 */
const PALETTE = [
  { bg: "bg-[#1A4331]/10", text: "text-forest" },
  { bg: "bg-[#E5A93D]/20", text: "text-[#8A5F1B]" },
  { bg: "bg-[#C25946]/15", text: "text-[#8F3C2C]" },
  { bg: "bg-[#4B6650]/15", text: "text-[#2E4A34]" },
  { bg: "bg-[#A87C3D]/20", text: "text-[#5B4620]" },
];

function tone(username = "") {
  let h = 0;
  for (let i = 0; i < username.length; i++) h = (h * 31 + username.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

function initials(name = "") {
  const cleaned = name
    .replace(/^DR\.?\s*/i, "")
    .replace(/\([^)]*\)/g, "") // strip parenthetical qualifiers like "(Shared)"
    .replace(/[^A-Za-z\s]/g, " ")
    .trim();
  const parts = cleaned.split(/\s+/).filter(Boolean);
  const chars = parts.slice(0, 2).map((p) => p[0]).join("");
  return chars.toUpperCase() || "?";
}

export default function DoctorAvatar({ doctor, size = 40, ring = false, testid }) {
  const s = { width: `${size}px`, height: `${size}px` };
  const url = doctor?.avatar_data_url;
  const ringCls = ring ? "ring-2 ring-white shadow-sm" : "";
  if (url) {
    return (
      <img
        src={url}
        alt={doctor?.name || "Doctor"}
        style={s}
        data-testid={testid}
        className={`rounded-full object-cover ${ringCls}`}
      />
    );
  }
  const t = tone(doctor?.username || doctor?.name || "?");
  const fs = Math.max(11, Math.round(size * 0.36));
  return (
    <div
      style={{ ...s, fontSize: `${fs}px` }}
      data-testid={testid}
      className={`rounded-full flex items-center justify-center font-bold tracking-wide ${t.bg} ${t.text} ${ringCls}`}
    >
      {initials(doctor?.name)}
    </div>
  );
}
